module.exports = __webpack_public_path__ + "img/search_round.c6d25cc9.svg";